import React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useTranslation } from 'react-i18next';
import styles from './styles';

type DownloadExcelModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (type: string) => void;
};
export default function DownloadExcelModal({
  isOpen,
  onClose,
  onSubmit,
}: DownloadExcelModalProps) {
  const classes = styles();
  const { t } = useTranslation();
  const DEFAULT_OPTION = t('operationHours.selectSettings');
  const [type, setType] = React.useState<any>(DEFAULT_OPTION);

  const onChange = event => {
    setType(event.target.value);
  };
  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
      data-testid="download-excel-modal"
    >
      <DialogTitle
        id="customized-dialog-title"
        className={classes.downloadModal}
      >
        <Grid container justifyContent="space-between">
          <Grid item>
            <Typography variant="h6" style={{ fontWeight: 600 }}>
              {t('operationHours.downloadFile')}
            </Typography>
          </Grid>
          <Grid item>
            <IconButton style={{ padding: 0 }} onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent
        className={`${classes.tabPanel} ${classes.downloadModalContent}`}
      >
        <FormControl variant="outlined" className={classes.formControl}>
          <Select
            value={type}
            onChange={onChange}
            inputProps={{
              name: 'type',
              id: 'excel-type',
            }}
          >
            <MenuItem value={DEFAULT_OPTION} disabled selected>
              {DEFAULT_OPTION}
            </MenuItem>
            <MenuItem value="Base">
              {t('operationHours.selectBaseAdjustment')}
            </MenuItem>
            <MenuItem value="Day">
              {t('operationHours.selectDayAdjustment')}
            </MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions className={classes.tabPanel}>
        <Button
          variant="contained"
          className={classes.downloadButton}
          color="primary"
          autoFocus
          onClick={onClose}
        >
          {t('app.common.cancel')}
        </Button>
        <Button
          variant="contained"
          className={classes.downloadButton}
          color="primary"
          autoFocus
          disabled={type && type === DEFAULT_OPTION}
          onClick={() => onSubmit(type)}
        >
          {t('operationHours.download')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
